module.exports = __webpack_public_path__ + "sk.4d5e47dc96b31ae992e2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sk.svg
// module chunks = styles